import { i18n } from '@lingui/core';
import { I18nProvider } from '@lingui/react';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { ErrorBoundary } from 'components/ErrorBoundary/ErrorBoundary';
import { ProductsLoader } from 'components/ProductsLoader/ProductsLoader';
import { IntroducerContextProvider } from 'contexts/IntroducerContext/IntroducerContext';

import '../index.css';
import 'applicationTable/Table.css';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import 'react-toastify/dist/ReactToastify.css';
import 'react-loading-skeleton/dist/skeleton.css';
import 'normalize.css';
import '../styles/shared.css';

import '@iwoca/orion/css/colors.css';
import '@iwoca/orion/css/radii.css';
import '@iwoca/orion/css/shadows.css';
import '@iwoca/orion/css/text.css';
import '@iwoca/orion/css/spacers.css';
import '@iwoca/orion/lib/css/orion.css';
import '@iwoca/orion/css/fonts.css';

import { ForbiddenPage } from 'pages/403';
import { NotFoundPage } from 'pages/404';
import { ApplicationOverviewPage } from 'pages/application/application';
import { DocumentsPage } from 'pages/application/documents/documents';
import { CheckDetailsPage } from 'pages/application/new/checkDetails';
import { NewApplicationPage } from 'pages/application/new/newApplication';
import { ProductOffersPage } from 'pages/application/new/productOffers/productOffers';
import { TradingHistoryPage } from 'pages/application/new/tradingHistory/tradingHistory';
import { CalculatorPage } from 'pages/calculator';
import { FAQsPage } from 'pages/faqs';
import { HomePage } from 'pages/home';
import { ProductsPage } from 'pages/products';
import { RegisterPage } from 'pages/register';
import { RegistrationDocumentsPage } from 'pages/registration-documents';
import { WhatsNewPage } from 'pages/whats-new';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { IwQueryClientProvider } from 'store/IwQueryClientProvider';
import {
  getBasename,
  initializeDataDog,
  initializeLingui,
  initialiseTracking,
} from './App.helpers';

initializeDataDog();
initializeLingui();
initialiseTracking();

export const App = () => {
  return (
    <I18nProvider i18n={i18n as any}>
      <IwQueryClientProvider>
        <Router basename={getBasename()}>
          <ErrorBoundary locale={i18n.locale}>
            <IntroducerContextProvider>
              <ProductsLoader>
                <Routes>
                  <Route path="/" Component={HomePage} />
                  <Route path="/products" Component={ProductsPage} />
                  <Route path="/register/*" Component={RegisterPage} />
                  <Route path="/faqs" Component={FAQsPage} />
                  <Route path="/calculator" Component={CalculatorPage} />
                  <Route path="/403" Component={ForbiddenPage} />
                  <Route path="/whats-new" Component={WhatsNewPage} />
                  <Route
                    path="/registration-documents"
                    Component={RegistrationDocumentsPage}
                  />
                  <Route
                    path="/application/new/productOffers"
                    Component={ProductOffersPage}
                  />
                  <Route
                    path="/application/new/documents"
                    Component={TradingHistoryPage}
                  />
                  <Route
                    path="/application/new/checkDetails"
                    Component={CheckDetailsPage}
                  />
                  <Route
                    path="/application/new"
                    Component={NewApplicationPage}
                  />
                  <Route
                    path="/application/documents"
                    Component={DocumentsPage}
                  />
                  <Route
                    path="/application"
                    Component={ApplicationOverviewPage}
                  />
                  <Route path="*" Component={NotFoundPage} />
                </Routes>
              </ProductsLoader>
            </IntroducerContextProvider>
          </ErrorBoundary>
        </Router>
        <ReactQueryDevtools initialIsOpen={false} />
      </IwQueryClientProvider>
    </I18nProvider>
  );
};
